export enum LoyaltyActionType {
  None = 0,
  Facebook_Connect = 101000,
  Facebook_LikeAPage = 101001,
  Facebook_PostOnWall = 101002,
  Facebook_ShareAPost = 101003,
  Facebook_CheckIn = 101004,
  Facebook_CommentOnPost = 101005,
  Facebook_LikePost = 101006,
  Facebook_LikeAComment = 101007,
  Facebook_PageVisit = 101008,
  Facebook_DeleteItem = 101102,
  Facebook_Disconnect = 101103,
  Facebook_Marketplace_Share = 101104,
  Facebook_Marketplace_Post = 101105,
  Facebook_Auction_Share = 101106,
  Facebook_Auction_Post = 101107,
  Facebook_Lottos_Share = 101108,
  Facebook_Lottos_Post = 101109,
  Twitter_Connect = 102000,
  Twitter_Follow = 102001,
  Twitter_HashTag = 102002,
  Twitter_Retweet = 102003,
  Twitter_Mention = 102004,
  Twitter_Photo = 102005,
  Twitter_Favorite = 102006,
  Twitter_SpredFastPost = 102007,
  Twitter_Disconnect = 102008,
  Twitter_Marketplace_Share = 102009,
  Twitter_Marketplace_Post = 102010,
  Twitter_Auction_Share = 102011,
  Twitter_Auction_Post = 102012,
  Twitter_Lottos_Share = 102013,
  Twitter_Lottos_Post = 102014,
  Google_Connect = 103000,
  Google_Follow = 103001,
  Google_Plus1 = 103002,
  Google_Comment = 103003,
  Google_Share = 103004,
  Google_Disconnect = 103005,
  FourSquare_Connect = 104000,
  FourSquare_CheckIn = 104001,
  FourSquare_OfferRedemption = 104002,
  FourSquare_Follow = 104003,
  FourSquare_VenueLike = 104004,
  FourSquare_Disconnect = 104005,
  Instagram_Connect = 105000,
  Instagram_Follow = 105001,
  Instagram_Like = 105002,
  Instagram_Comment = 105003,
  Instagram_PostPhoto = 105004,
  Instagram_HashTag = 105005,
  Instagram_Mention = 105006,
  Instagram_SpredFastPost = 105007,
  Instagram_Disconnect = 105008,
  Youtube_Connect = 106000,
  Youtube_Subscribe = 106001,
  Youtube_Like = 106002,
  Youtube_View = 106003,
  Youtube_Comment = 106004,
  Youtube_Disconnect = 106005,
  LoginToPortal = 200001,
  LoginToPortal3rdParty = 200002,
  LoginToPortalSSO = 200003,
  LoginIntoChildAccount = 200004,
  SwitchAccount = 200005,
  LoginIntoGuardian = 200006,
  SwitchClub = 200007,
  Attendance = 200010,
  AddPartner = 200011,
  AddPartnerNewMember = 200012,
  DeletePendingPartner = 200013,
  ReferredAFriend = 200014,
  ReferredByAFriend = 200015,
  PartnerRemoved = 200016,
  AnswerSurvey = 200020,
  AnswerPoll = 200021,
  AnswerFeedBack = 200022,
  BuySweepstake = 200023,
  BuyRaffle = 200024,
  PlaceAuctionBid = 200025,
  AuctionOutBid = 200026,
  AuctionItemWon = 200027,
  AnswerSurveyCorrect = 200028,
  AnswerSurveyCorrectBonus = 200029,
  ConnectToMLBAM = 200030,
  WatchVideoInPortal = 200031,
  UpgradeMembershipLevel = 200032,
  AutoTopUpSubscription = 200033,
  BirthdayBonusPoints = 200034,
  MarketplacePurchase = 200035,
  MarketplaceEventPurchase = 200036,
  MarketplaceDownloadPurchase = 200037,
  MarketplaceVoucherPurchase = 200038,
  MarketplaceVirtualEventPurchase = 200039,
  FanAssit = 200040,
  FanAssit_Tickets = 200041,
  AttachTicketMasterAccount = 200042,
  AnswerPredictorCorrectly = 200043,
  AnswerTrivia = 200044,
  AnswerPredictor = 200045,
  AuctionItemLost = 200046,
  NewAccountCreation = 200050,
  NewPartnerAccountCreation = 200051,
  NewFriendAccountCreation = 200052,
  AccountActivation = 200053,
  LinkChildAccount = 200054,
  CardReprintRequest = 200055,
  CardReprintRequestOrderProcessed = 200056,
  ProductCodeChanged = 200057,
  AccountCreatedViaSync = 200058,
  MarketplaceTransferCompleted = 200059,
  Fantasy_PlayerSelection = 200060,
  PortalProductPurchase = 200061,
  PortalProductMembershipPurchase = 200062,
  PortalProductAccDescriptionPurchase = 200063,
  ChildCardPrint = 200064,
  GuardianCardPrint = 200065,
  Questions = 200066,
  AdminUpgradeChildAccount = 200067,
  PortalProductDiscountPurchase = 200068,
  PortalProductUpgradeMembership = 200069,
  CardSubscriptionAdded = 200070,
  PortalProductRsnMembershipSubscriptionAdded = 200071,
  NewGuardianAccountCreated = 200072,
  NewChildAccountCreated = 200073,
  NewExternalAccountCreated = 200074,
  DownloadWorksheetClick = 200075,
  CustomerTagUpdated = 200076,
  ScorecardComplete = 200077,
  BenefitClaimed = 200078,
  AttendanceCheckIn = 200079,
  EcashSpend = 200080,
  LottoWon = 200081,
  PortalProductPointsPurchase = 200082,
  ScorecardMilestoneComplete = 200083,
  ReadArticle = 200084,
  SKUPurchase = 200085,
  ScorecardActionComplete = 200086,
  SKUBasketPurchase = 200087,
  WorksheetItemActivated = 200088,
  RedeemMarketplaceCoupon = 200089,
  CompleteProfile = 200090,
  DeletePendingChild = 200091,
  AddPendingChild = 200092,
  PaymentTopUpAmericanExpress = 210000,
  PaymentTopUpVisa = 210001,
  PaymentTopUpMasterCard = 210002,
  PaymentTopUpDiscover = 210003,
  PaymentTopUpJCB = 210004,
  PaymentTopUpDebit = 210005,
  PaymentTopUpOther = 210006,
  PaymentAutoTopUpAmericanExpress = 210020,
  PaymentAutoTopUpVisa = 210021,
  PaymentAutoTopUpMasterCard = 210022,
  PaymentAutoTopUpDiscover = 210023,
  PaymentAutoTopUpJCB = 210024,
  PaymentAutoTopUpDebit = 210025,
  PaymentAutoTopUpOther = 210026,
  PaymentRecurringSubscriptionSuccessfullyCompleted = 210050,
  PaymentRecurringSubscriptionFailedCompleted = 210051,
  PaymentRecurringSubscriptionCancelledCompleted = 210052,
  PaymentGatewayTransaction = 211000,
  CardLinkTransaction = 212000,
  CardLinkAddNewCard = 212001,
  OnlineAffiliateTransaction = 212100,
  VoucherCodeEntered = 220000,
  MarketPlaceOrderProcessed = 220001,
  PaymentTopUpCompleted = 220002,
  AuctionNotification = 230000,
  MarketplaceNotification = 230001,
  LottoNotification = 230002,
  SurveyNotification = 230003,
  FantasyNotification = 230004,
  DigitialTicketingNotification = 230005,
  EcashNotification = 230006,
  PointsNotification = 230007,
  RewardsNotification = 230008,
  MLBAMNotification = 230009,
  AffiliateNotification = 230010,
  CampaignManagerNotification = 231000,
  ScorecardExpirationNotification = 231001,
  ScorecardActivationNotification = 231002,
  AuctionExpirationNotification = 231011,
  AuctionActivationNotification = 231012,
  TicketTransferOrder = 240000,
  TicketTransferSentTicket = 240001,
  TicketTransferRecieveTicket = 240002,
  TicketTransferSendInviteTicket = 240003,
  TicketTransferAcceptTicket = 240004,
  TicketTransferCallBackTicket = 240005,
  TicketDonationOrder = 240020,
  TicketDonationSentTicket = 240021,
  TicketDonationRecieveTicket = 240022,
  TicketResaleOrder = 240030,
  TicketResalePlaceTicketOnResaleTicket = 240031,
  TicketResaleSellTicket = 240032,
  TicketResaleBuyTicket = 240033,
  SiteVisit = 300000,
  SidelineSportsRiskIt = 300100,
  SidelineSportsPick3 = 300101,
  SidelineSportsBingo = 300102,
  ThirdPartySSOReturn = 310000,
  TransactionsAccess = 400001,
  TransactionsPayment = 400002,
  TransactionsLoyalty = 400003,
  TransactionsInteractions = 400004,
  TransactionsSocial = 400005,
  TransactionsCorrection = 400006,
  TransactionsRefund = 400007,
  TransactionsMarketplace = 400031,
  TransactionsAuctions = 400032,
  TransactionsCompetitions = 400033,
  TransactionsVoucherCode = 400041,
  TransactionsCheckIns = 400042,
  TransactionsPollsSurveys = 400043,
  TransactionsTrivia = 400044,
  TransactionsFantasy = 400045,
  BingoFantasy = 400046,
  DebitAccountGPSSuccess = 500000,
  DebitAccountGPSFail = 500001,
  CreditAccountGPSTopUp = 500002,
  CreditAccountGPSAutoTopUp = 500003,
  LoyaltyEmailAlert = 510001,
  LoyaltyEmailAlert2 = 510002,
  LoyaltyEmailAlert3 = 510003,
  JoinWebCall = 510004,
}
